/**
 * VersionBadge - Exibe versão do app no canto inferior direito
 *
 * Mostra versão do package.json + hash do commit git
 * Fixado no canto com opacidade baixa para não interferir na UI
 */

interface VersionBadgeProps {
  className?: string;
}

export function VersionBadge({ className }: VersionBadgeProps) {
  // Variáveis injetadas pelo Vite em build time
  const version = import.meta.env.VITE_APP_VERSION || '1.0.0';
  const commitHash = import.meta.env.VITE_COMMIT_HASH || 'dev';

  return (
    <div
      className={`fixed bottom-2 right-2 z-50 pointer-events-none select-none ${className || ''}`}
      style={{ opacity: 0.3 }}
    >
      <span className="text-[10px] font-mono text-muted-foreground">
        v{version} ({commitHash})
      </span>
    </div>
  );
}
